import { Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Layout } from "@/components/site/Layout";
import { RouteFallback } from "@/components/site/RouteFallback";
import {
  Home,
  About,
  Services,
  Realisations,
  Contact,
  MentionsLegales,
  Confidentialite,
  NotFound,
} from "@/routes/registry";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home.Component />} />
              <Route path="/a-propos" element={<About.Component />} />
              <Route path="/services" element={<Services.Component />} />
              <Route path="/realisations" element={<Realisations.Component />} />
              <Route path="/contact" element={<Contact.Component />} />
              <Route path="/mentions-legales" element={<MentionsLegales.Component />} />
              <Route path="/politique-confidentialite" element={<Confidentialite.Component />} />
            </Route>
            <Route path="*" element={<NotFound.Component />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
